module.exports = __webpack_public_path__ + "static/media/mall_logo_bottom.098e76a7.png";